import {useContext} from 'react'

import Context from '@s-ui/react-context'

const useSellerType = contractId => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {PRIVATE_CONTRACT_ID} = config.get('dealer')

  const contractIdNumber = Number(contractId)

  const isPrivate = contractIdNumber === PRIVATE_CONTRACT_ID
  const isDealer = contractIdNumber > PRIVATE_CONTRACT_ID

  return {isDealer, isPrivate}
}

export {useSellerType}
